import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,useNavigate } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import PublicMenu from '../components/menus/PublicMenu';
import {validateInput as _vli,validateAllUIInputs as _vlai,stringToHex} from "./../components/forms/validator";
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../constants';
import $ from 'jquery';
import axios from 'axios';
import Waiter from './../assets/gif/blueCircle.gif';
const GlobalStyles = createGlobalStyle`
	
`;
let loginInfo={
	email:"",
	password:"",
	cp:""
};
const JPage= (props) =>{
	const navigate=useNavigate();
	const [loginInfoData,setLoginInfoData]=useState(loginInfo);
	const [message,setMessage]=useState("");
	const [fetchOnReq,setFecthOnReq]=useState(false);
	useEffect(()=>{
		//if(window.location.pathname==="/"){ getCaptcha();}
		//else navigate(window.location.pathname);
	},[])
	const login=()=>{
		setFecthOnReq(true);
		setMessage("wait...");
		let idata=stringToHex(JSON.stringify(loginInfoData));
		$.post(API_CORE_SERVER+"/api/user/login.php","i="+idata,async function(result) {
			if(result.status===1){ 
				let resData=result.data;
				localStorage.setItem("_xoxex",resData.token);// token is logined or not
				localStorage.setItem("_lio",resData.token);// token is logined or not
				localStorage.setItem("_xoxre",resData.role);
				localStorage.setItem("_xoxdp",resData.department);
				localStorage.setItem("_xoxem",resData.email);
				localStorage.setItem("_xoxdpn",resData.departmentname??resData.email);
				navigate(URLPREFIX+"/view/dashboard")
			}
			setMessage(result.msg);
			setFecthOnReq(false);
		},'json')
		.fail(function(response) {
			setFecthOnReq(false);	
		});
	}
	function getCaptcha(e)
	{
		e.preventDefault();
		var param="c=78346832746";
		console.log("HELO MINJI");
		$.post(API_CORE_SERVER+"/api/tools/Captcha.php", param, function(result) {
				try{
					console.log("Hello"+result);
					if(result==="Unauthorized") {alert("Your Captcha Session has been expired , after 5 attempt");}
					$("#imgCaptcha").attr("src",result);
				}catch(e) {console.log("Image EXCEPTION:"+result);}
			}, 'text')
			.fail(function(response) {
								
			});
		return(false);
	}
	
  return(
  <div className="wraper">
		<GlobalStyles/>
		<PublicMenu />
		<div className='row'>
					<div className='col-md-4 p-4 rounded-2 mt-4 mx-auto' style={{backgroundColor:'#ffffff'}}>
						<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i> Login</h5>
						<div className="row">
							<div className='col'>	
									<div className="form-floating mb-3 mt-3">
										<input type="text" autoComplete='off' className="form-control jform-control" id="email"
										value={loginInfoData.email}  placeholder="Enter email id" 
										onChange={e=>{setLoginInfoData((prev)=>{return {...prev,email:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
										<label>Enter email address</label>
									</div>
							</div>
						</div>
						<div className="row">
							<div className='col'>	
									<div className="form-floating mb-3 mt-3">
										<input type="password" autoComplete='off' className="form-control jform-control" id="password"
										value={loginInfoData.password}  placeholder="Enter password" 
										onChange={e=>{setLoginInfoData((prev)=>{return {...prev,password:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
										<label>Enter password</label>
									</div>
							</div>
						</div>
						{/*<div className='row'>
						<div className="col-md-6">
							<div className='jinput'>
								<div className="input-group">
									<img id="imgCaptcha" src="" className="form-control-captcha" />
								</div>
								<div className='text-primary cursor-pointer' style={{fontSize:'0.85rem'}} onClick={e=> getCaptcha(e)} >Refresh Captcha</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className='jinput'>
								<div className="input-group">
									<input type="text" className="form-control icheck"  id="cp" name="cp"  onChange={e=>{setLoginInfoData((prev)=>{return {...prev,cp:e.target.value}});}} placeholder="Enter captcha code" />
								</div>
								<div className='jd-none'></div>
							</div>
						</div>	
  						</div>*/}
						<div className='row'>
							<div className='col'>	
								<div className="text-end mb-3 mt-3">
									<button className='btn btn-secondary px-4 py-2'
									onClick={(e)=>{
										_vlai();
										let redBoxes=$(".form-control-error");
										if(redBoxes && redBoxes.length===0)
											login();
									}}
									> Login </button>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>	
								<div className="text-end mb-3 mt-3">
								{fetchOnReq===true? 
									<>
										<img src={Waiter} className='waiter-md'/>
									</>
									:<>{message}</>
								}
								</div>
							</div>
						</div>
					</div>	
		</div>				
  </div>	
	);
};
export default JPage;